import React from 'react';
import clsx from 'clsx';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
    name?: string | null;
    src?: string | null;
    /** 36 / 44 / 56 */
    size?: 'sm' | 'md' | 'lg';
    status?: 'online' | 'off';
    ring?: boolean;
}

const sizes = { sm: 'w-9 h-9 text-[13px]', md: 'w-11 h-11 text-[15px]', lg: 'w-14 h-14 text-lg' };

export const initials = (name?: string | null) =>
    (name || '')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('') || '?';

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = 'md', status, ring = false, className, ...props }) => (
    <div
        className={clsx(
            'relative inline-flex shrink-0 select-none items-center justify-center rounded-full bg-primary-500 font-extrabold text-white',
            sizes[size],
            ring && 'shadow-[0_0_0_3px_var(--surface-card),0_0_0_5px_var(--accent)]',
            className,
        )}
        aria-label={name ?? undefined}
        {...props}
    >
        {src ? <img src={src} alt={name ?? ''} className="w-full h-full rounded-full object-cover" /> : initials(name)}
        {status && (
            <span
                className={clsx(
                    'absolute right-0 bottom-0 w-[28%] h-[28%] min-w-[9px] min-h-[9px] rounded-full border-2 border-surface-card',
                    status === 'online' ? 'bg-status-success' : 'bg-neutral-400',
                )}
            />
        )}
    </div>
);
export default Avatar;
